import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
import { trackEvent as track } from '../../utils/analytics';
import { trustFinalCta as c, type Bi } from '../../data/trustSolution';
const EASE = [0.23, 1, 0.32, 1] as const;
export function TrustFinalCTA() {
  const {
    lang
  } = useLanguage();
  const pick = (b: Bi) => lang === 'FR' ? b.fr : b.en;
  return <section className="relative overflow-hidden bg-[#FCFBFF] border-t border-[#EEF0F4] px-6 py-28 lg:py-36" aria-labelledby="trust-cta-title" data-id="element-7013" data-mp="ypvwv4ab0e4z">
      <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[760px] h-[420px] rounded-full bg-[#EEEDFD] opacity-70 blur-[140px]" aria-hidden="true" data-id="element-7014" data-mp="13qjvab0v3x98" />
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.3,
      ease: EASE
    }} className="relative max-w-[900px] mx-auto text-center" data-id="element-7015" data-mp="35hx0l16qs75t">
        <p className="font-sans text-[12px] font-semibold tracking-[0.22em] uppercase text-[#4F46E5]" data-id="element-7016" data-mp="3n0xw66veziz9">{pick(c.eyebrow)}</p>
        <h2 id="trust-cta-title" className="mt-6 font-serif text-[2.2rem] sm:text-[3rem] lg:text-[3.5rem] leading-[1.06] tracking-tight text-[#121A3A]" data-id="element-7017" data-mp="3i2wffslgnvqy">
          {pick(c.headline.before)}
          <span className="text-[#4F46E5]" data-id="element-7018" data-mp="ekcw5fkrg08a">{pick(c.headline.accent)}</span>
          <br className="hidden sm:block" data-id="element-7019" data-mp="9lrtzaly76h7" /> {pick(c.headline.after)}
        </h2>
        <p className="mt-7 mx-auto max-w-[640px] font-sans text-[16px] md:text-[18px] text-[#5A6178] leading-relaxed" data-id="element-7020" data-mp="4n86h5rphmmq">{pick(c.body)}</p>
        <Link to="/request-demo" onClick={() => track('Demo CTA Clicked', {
        location: 'Trust Final CTA'
      })} className="mt-9 inline-flex w-full sm:w-auto items-center justify-center gap-4 rounded-md bg-[#4F46E5] px-9 py-4 font-sans text-[17px] font-medium text-white hover:bg-[#4338CA] transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4F46E5] focus-visible:ring-offset-2" data-id="element-7021" data-mp="3vshoob9gkwls">
          {pick(c.cta)}
          <ArrowRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-7022" data-mp="12h94wgxffyza" />
        </Link>
        <p className="mt-16 font-sans text-[12.5px] tracking-[0.14em] uppercase text-[#8A86B8]" data-id="element-7023" data-mp="17fu72lw8osqd">{pick(c.signature)}</p>
      </motion.div>
    </section>;
}